import { sendGet } from '../helpers/axiosRecruit';

export const apiGetStandbyUsers = (params) => sendGet('/api/candidate/list-user-pending', params);